import { render, staticRenderFns } from "./UserActions.vue?vue&type=template&id=7984129b&scoped=true"
import script from "./UserActions.vue?vue&type=script&lang=js"
export * from "./UserActions.vue?vue&type=script&lang=js"
import style0 from "./UserActions.vue?vue&type=style&index=0&id=7984129b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7984129b",
  null
  
)

export default component.exports